export default "__VITE_ASSET__Qd4ZUCuP__"